import { render, staticRenderFns } from "./infoChip.vue?vue&type=template&id=62287e17&scoped=true&"
import script from "./infoChip.vue?vue&type=script&lang=js&"
export * from "./infoChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62287e17",
  null
  
)

export default component.exports